module.exports = __webpack_public_path__ + "img/chintai.a0a65d6b.png";